/**
 * ANQ.UserProfile.API 
 * User Profile Service
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ChangePasswordResponseModel } from '../model/changePasswordResponseModel';
import { ForgotPasswordResponse } from '../model/forgotPasswordResponse';
import { JwtDto } from '../model/jwtDto';
import { ResetPasswordResponseModel } from '../model/resetPasswordResponseModel';
import { UserAuthenticationResponse } from '../model/userAuthenticationResponse';
import { UserValidateRequest } from '../model/userValidateRequest';
import { UserValidationRequest } from '../model/userValidationRequest';
import { VerifyAccountModelDto } from '../model/verifyAccountModelDto';

import { IDENTITY_BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class AuthenticationService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(IDENTITY_BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param email 
     * @param newPassword 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAuthenticationChangePasswordIdentityPost(email?: string, newPassword?: string, observe?: 'body', reportProgress?: boolean): Observable<ChangePasswordResponseModel>;
    public apiAuthenticationChangePasswordIdentityPost(email?: string, newPassword?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ChangePasswordResponseModel>>;
    public apiAuthenticationChangePasswordIdentityPost(email?: string, newPassword?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ChangePasswordResponseModel>>;
    public apiAuthenticationChangePasswordIdentityPost(email?: string, newPassword?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (email !== undefined && email !== null) {
            queryParameters = queryParameters.set('email', <any>email);
        }
        if (newPassword !== undefined && newPassword !== null) {
            queryParameters = queryParameters.set('newPassword', <any>newPassword);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ChangePasswordResponseModel>('post',`${this.basePath}/api/Authentication/ChangePasswordIdentity`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param email 
     * @param currentPassword 
     * @param newPassword 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAuthenticationChangePasswordWithCurrentPasswordIdentityPost(email?: string, currentPassword?: string, newPassword?: string, observe?: 'body', reportProgress?: boolean): Observable<ChangePasswordResponseModel>;
    public apiAuthenticationChangePasswordWithCurrentPasswordIdentityPost(email?: string, currentPassword?: string, newPassword?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ChangePasswordResponseModel>>;
    public apiAuthenticationChangePasswordWithCurrentPasswordIdentityPost(email?: string, currentPassword?: string, newPassword?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ChangePasswordResponseModel>>;
    public apiAuthenticationChangePasswordWithCurrentPasswordIdentityPost(email?: string, currentPassword?: string, newPassword?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (email !== undefined && email !== null) {
            queryParameters = queryParameters.set('email', <any>email);
        }
        if (currentPassword !== undefined && currentPassword !== null) {
            queryParameters = queryParameters.set('currentPassword', <any>currentPassword);
        }
        if (newPassword !== undefined && newPassword !== null) {
            queryParameters = queryParameters.set('newPassword', <any>newPassword);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ChangePasswordResponseModel>('post',`${this.basePath}/api/Authentication/ChangePasswordWithCurrentPasswordIdentity`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param email 
     * @param resetPasswordURL 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAuthenticationForgotPasswordIdentityPost(email?: string, resetPasswordURL?: string, observe?: 'body', reportProgress?: boolean): Observable<ForgotPasswordResponse>;
    public apiAuthenticationForgotPasswordIdentityPost(email?: string, resetPasswordURL?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ForgotPasswordResponse>>;
    public apiAuthenticationForgotPasswordIdentityPost(email?: string, resetPasswordURL?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ForgotPasswordResponse>>;
    public apiAuthenticationForgotPasswordIdentityPost(email?: string, resetPasswordURL?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (email !== undefined && email !== null) {
            queryParameters = queryParameters.set('email', <any>email);
        }
        if (resetPasswordURL !== undefined && resetPasswordURL !== null) {
            queryParameters = queryParameters.set('resetPasswordURL', <any>resetPasswordURL);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ForgotPasswordResponse>('post',`${this.basePath}/api/Authentication/ForgotPasswordIdentity`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAuthenticationLoginPost(body?: UserValidateRequest, observe?: 'body', reportProgress?: boolean): Observable<JwtDto>;
    public apiAuthenticationLoginPost(body?: UserValidateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<JwtDto>>;
    public apiAuthenticationLoginPost(body?: UserValidateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<JwtDto>>;
    public apiAuthenticationLoginPost(body?: UserValidateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<JwtDto>('post',`${this.basePath}/api/Authentication/login`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param userId 
     * @param token 
     * @param newPassword 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAuthenticationResetPasswordIdentityPost(userId?: string, token?: string, newPassword?: string, observe?: 'body', reportProgress?: boolean): Observable<ResetPasswordResponseModel>;
    public apiAuthenticationResetPasswordIdentityPost(userId?: string, token?: string, newPassword?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResetPasswordResponseModel>>;
    public apiAuthenticationResetPasswordIdentityPost(userId?: string, token?: string, newPassword?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResetPasswordResponseModel>>;
    public apiAuthenticationResetPasswordIdentityPost(userId?: string, token?: string, newPassword?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (userId !== undefined && userId !== null) {
            queryParameters = queryParameters.set('userId', <any>userId);
        }
        if (token !== undefined && token !== null) {
            queryParameters = queryParameters.set('token', <any>token);
        }
        if (newPassword !== undefined && newPassword !== null) {
            queryParameters = queryParameters.set('newPassword', <any>newPassword);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ResetPasswordResponseModel>('post',`${this.basePath}/api/Authentication/ResetPasswordIdentity`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAuthenticationValidatehubuserPost(body?: UserValidationRequest, observe?: 'body', reportProgress?: boolean): Observable<UserAuthenticationResponse>;
    public apiAuthenticationValidatehubuserPost(body?: UserValidationRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserAuthenticationResponse>>;
    public apiAuthenticationValidatehubuserPost(body?: UserValidationRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserAuthenticationResponse>>;
    public apiAuthenticationValidatehubuserPost(body?: UserValidationRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<UserAuthenticationResponse>('post',`${this.basePath}/api/Authentication/Validatehubuser`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param userId 
     * @param token 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAuthenticationVerifyUserAccountPost(userId?: string, token?: string, observe?: 'body', reportProgress?: boolean): Observable<VerifyAccountModelDto>;
    public apiAuthenticationVerifyUserAccountPost(userId?: string, token?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<VerifyAccountModelDto>>;
    public apiAuthenticationVerifyUserAccountPost(userId?: string, token?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<VerifyAccountModelDto>>;
    public apiAuthenticationVerifyUserAccountPost(userId?: string, token?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (userId !== undefined && userId !== null) {
            queryParameters = queryParameters.set('userId', <any>userId);
        }
        if (token !== undefined && token !== null) {
            queryParameters = queryParameters.set('token', <any>token);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<VerifyAccountModelDto>('post',`${this.basePath}/api/Authentication/VerifyUserAccount`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
